var App = App || {};

App.ZagTooltips = (function ($) {
    "use strict";

    const ttpWidth = 207;
    var zagTtpBtns = $(".zag-tooltip-btn");
    var zagTtpWrappers = $(".zag-tooltip-wrapper");

    function init() {
        zagTtpBtns.on("mouseenter", function () {
            $(this).addClass("hovered");
            if (!$(this).parents(".splide__slide").length || $(this).parents(".splide__slide").hasClass("is-visible")) { // don't open tooltips on inactive slides
                openTooltipByBtn($(this));
            }
        }).on("mouseleave", function () {
            $(this).removeClass("hovered");
            checkToCloseBtn($(this));
        }).on("focusin", function () {
            //do nothing, allow user to enter manually
        }).on("focusout", function () {
            checkToCloseBtn($(this));
        }).on("click", function () {
            if (!$(this).hasClass("clicked")){
                $(this).addClass("clicked");
                openTooltipByBtn($(this));
            } else {
                $(this).removeClass("clicked");
            }
        });

        $(document).on('click', function (event) {
            if ($(".zag-tooltip-btn.clicked").length) {
                if (!$(event.target).closest(".zag-tooltip-btn.clicked").length && !$(event.target).closest(".zag-tooltip-wrapper").length) {
                    closeAllTooltips()
                }
            }
        });

        zagTtpBtns.on("keydown", function (e) {
            if (e.key === " " || e.key === "Enter") {
                e.preventDefault();
                openTooltipByBtn($(this), true);
            }
        });

        zagTtpWrappers.on("mouseenter", function () {
            $(this).addClass("hovered");
        }).on("mouseleave", function () {
            $(this).removeClass("hovered");
            checkToCloseBtn($("[data-ttid=" + $(this).attr("id") + "]"));
        }).on("focusin", function () {
            $(this).addClass("focused");
        }).on("focusout", function () {
            $(this).removeClass("focused");
            closeTooltipByBtn($("[data-ttid=" + $(this).attr("id") + "]"));
        });

        $(window).resize(function () {
            closeAllTooltips();
        })

        zagTtpWrappers.each(function () {
            $(this).find("a, button").attr("tabindex", "-1").addClass("ttp-hidden");

            if ($(this).find("a, button").length) {
                var ttpLastFocusable = $(this).find("a, button").last();

                ttpLastFocusable.on("keydown", function (e) {
                    if (e.key === "Tab") {
                        e.preventDefault();
                        $("[data-ttid=" + $(this).parents(".zag-tooltip-wrapper").attr("id") + "]").focus();
                    }
                });
            }
        });
    }

    function openTooltipByBtn($tooltipBtn, giveFocus = false) {
        var $containingWidget = $tooltipBtn.parents(".widget");
        //get position of button
        var btnRelOffsetLeft = $tooltipBtn.offset().left + $tooltipBtn.outerWidth() - 15 - $containingWidget.offset().left;
        var btnRelOffsetTop = $tooltipBtn.offset().top - $containingWidget.offset().top;
        var indicatorOffset = 0;

        //force tooltip onscreen
        if (btnRelOffsetLeft < ttpWidth / 2) {
            indicatorOffset = (ttpWidth / 2) - btnRelOffsetLeft;
            btnRelOffsetLeft = (ttpWidth / 2);
        }
        else if (btnRelOffsetLeft > $containingWidget.outerWidth() - (ttpWidth / 2)) {
            indicatorOffset = $containingWidget.outerWidth() - (ttpWidth / 2) - btnRelOffsetLeft;
            btnRelOffsetLeft = $containingWidget.outerWidth() - (ttpWidth / 2);
        }

        var $tooltip = $("#" + $tooltipBtn.data("ttid"));
        $tooltip.css({ top: btnRelOffsetTop, left: btnRelOffsetLeft, height: "fit-content", width: "20.7rem", overflow: "visible" }); //position tooltip
        $tooltip.find(".ttp-indicator").css("left", "calc(50% - " + indicatorOffset + "px)"); //offset indicator if tooltip is not centered
        $tooltip.attr("aria-hidden", false).addClass("open").find("a, button").attr("tabindex", '0').removeClass("ttp-hidden");;

        if (giveFocus) {
            setTimeout(function () {
                $tooltip.find("a, button").focus();
            }, 100);
        }
    }

    function checkToCloseBtn($tooltipBtn) {
        setTimeout(function () {
            var $tooltip = $("#" + $tooltipBtn.data("ttid"));

            if (!$tooltipBtn.hasClass("clicked") && !$tooltipBtn.hasClass("hovered") && !$tooltip.hasClass("hovered") && !$tooltip.hasClass("focused")) {
                closeTooltipByBtn($tooltipBtn);
            }
        }, 100);
    }

    function closeTooltipByBtn($tooltipBtn) {
        $tooltipBtn.removeClass("clicked");

        var $tooltip = $("#" + $tooltipBtn.data("ttid"));
        $tooltip.css({ top: 0, left: 0, height: 0, width: 0, overflow: "hidden" })
        $tooltip.attr("aria-hidden", true).removeClass("open").find("a, button").attr("tabindex", "-1").addClass("ttp-hidden");
    }

    function closeAllTooltips() {
        zagTtpBtns.each(function () {
            closeTooltipByBtn($(this));
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ZagTooltips.init();
});